import { GiftCodeDateType } from '@src/models/giftCodeDateType';

export const giftCodeDateTypeLabel: Record<GiftCodeDateType, string> = {
  [GiftCodeDateType.CREATED_AT]: '발급일',
  [GiftCodeDateType.ISSUED_AT]: '지급일',
  [GiftCodeDateType.USED_AT]: '사용일'
};
